import { useLayoutEffect, useState } from 'react';

const getMatchesMinWidth = (breakpoint) => window.matchMedia(`(min-width: ${breakpoint})`).matches;

const useMatchBreakpoint = (breakpoint, { shouldMatchOnMount = false } = {}) => {
  const [isMatches, setIsMatches] = useState(() =>
    shouldMatchOnMount ? getMatchesMinWidth(breakpoint) : false
  );

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${breakpoint})`);
    const handleChange = ({ matches }) => setIsMatches(matches);
    const shouldUseOldListeners = !mediaQuery.addEventListener;

    handleChange(mediaQuery);
    if (shouldUseOldListeners) {
      mediaQuery.addListener(handleChange);
    } else {
      mediaQuery.addEventListener('change', handleChange);
    }

    return () => {
      if (shouldUseOldListeners) {
        mediaQuery.removeListener(handleChange);
      } else {
        mediaQuery.removeEventListener('change', handleChange);
      }
    };
  }, [breakpoint]);

  return isMatches;
};

export default useMatchBreakpoint;
